import {
  faChevronDown,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { checkRequestData, setRequestData } from "../../redux/actions/certificateVerification";
import { SET_REQUEST_CV_STATUS, SET_USER_FORM_DATA } from "../../redux/actions/types";
import { toast } from "react-toastify";
import { PhoneNumberUtil } from "google-libphonenumber";
import { Mixpanel } from "../../config/Mixpanel";
import Constants from "../../common/constants";

const RequestCV = ({isActive , setIsActive}) => {
  
  const [formData, setFormData] = useState({
    role: "",
    number: "",
    reason: "",
  });
  const dispatch = useDispatch();
  const userDetails = useSelector((store) => store?.certificateVerification?.userInfo);
  const certificateData = useSelector((store) => store?.certificateVerification?.certificateData);
  const [isShow , setIsShow] = useState(true);
   const phoneUtil = PhoneNumberUtil.getInstance();
   const variant = useSelector((store)=> store?.certificateVerification?.userType);
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

 const validatePhoneNumber = (phoneNumber) => {
  try {
    if (!phoneNumber || typeof phoneNumber !== "string") {
      toast.error("Phone number must be a non-empty string");
      return false;
    }

    if (phoneNumber.startsWith("+")) {
      // Check format: + followed by digits only
      const regex = /^\+\d+$/;
      if (!regex.test(phoneNumber)) {
        toast.error("Phone number must start with + followed by digits only");
        return false;
      }

      // Validate as international number
      const parsedNumber = phoneUtil.parseAndKeepRawInput(phoneNumber);
      if (!phoneUtil.isValidNumber(parsedNumber)) {
        toast.error("Invalid international phone number");
        return false;
      }

      return true;
    } else {
      // Only digits allowed in local format
      const regex = /^\d+$/;
      if (!regex.test(phoneNumber)) {
        toast.error("Phone number must contain digits only");
        return false;
      }

      // Check local number length (e.g., 10 for India)
      if (phoneNumber.length !== 10) {
        toast.error("Local phone number must be 10 digits");
        return false;
      }

      return true;
    }

  } catch (error) {
    toast.error("Invalid phone number format");
    return false;
  }
};

  const submit = (e)=>{
      e.preventDefault();


      if(variant === "recruiter"){
        Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_RECRUITER_PAGE_REQUEST_CV_SUBMIT_BUTTON_CLICKED);
      }
      else{
        Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_NORMAL_PAGE_REQUEST_CV_SUBMIT_BUTTON_CLICKED);
      }
      

    if(!validatePhoneNumber(formData?.number))
        return;
    dispatch(setRequestData(userDetails?.email , 'cv' , formData?.role , formData?.number , formData?.reason , certificateData?.unique_certificate_id , (successObj)=>{

        const newUserDetails  = {...userDetails, phone_number : formData?.number};
        dispatch({type : SET_USER_FORM_DATA , payload : newUserDetails});
        setIsShow(false);
        dispatch(({type : SET_REQUEST_CV_STATUS , payload : true}))
    } , (errorObj)=>{}));
  }


useEffect(()=>{

  if(certificateData?.unique_certificate_id && userDetails?.email ){
    dispatch(checkRequestData(userDetails?.email , certificateData?.unique_certificate_id, 'cv' , (successObj)=>{

    if(successObj?.data?.show_empty === true){
      setIsShow(true);
      dispatch(({type : SET_REQUEST_CV_STATUS , payload : false}))
    }
    else{
      setIsShow(false);
      dispatch(({type : SET_REQUEST_CV_STATUS , payload : true}))
    }

    }, (errorObj)=>{}));
  }

},[ certificateData?.unique_certificate_id, dispatch, userDetails?.email])

  return (
  
      <div className="rounded-lg bg-[#4285F4]/10 border border-[#4285F4]/50 p-3">
        <div
          className=" relative flex items-center justify-start gap-2 cursor-pointer "
          onClick={(e) => setIsActive(!isActive)}
        >
          <div className="flex flex-1 items-center justify-start gap-2">
            <img
              src="https://assets.learntube.ai/files/Certificate%20Verification%20Screen/requestCv.png?updatedAt=1750520500587"
              alt=""
              className="h-[28px] w-[28px]"
              width={28}
              height={28}
            />
            <div className="flex flex-col items-start justify-center gap-2 leading-tight">
              <div className="text-[16px] font-medium text-white md:text-[18px]">
                Request CV & LinkedIn Profile
              </div>
              <div className="text-[12px] text-white/50 md:text-[14px]">
                Get {certificateData?.name?.split(" ")[0]}'s CV & LinkedIn profile in your inbox
              </div>
            </div>
          </div>
          <FontAwesomeIcon
            icon={isActive ? faChevronDown : faChevronRight}
            size="md"
            className="absolute right-0 text-white "
          />
        </div>
        {isActive && (
           isShow ? <form className="flex w-full flex-col mt-3 items-start justify-start gap-3" onSubmit={submit}>
            {variant === "recruiter" && <div className="w-full rounded-lg bg-[#18345A] p-3">
              <label className="text-[14px] text-white/70 md:text-[16px]">
                Role you're hiring for*
              </label>
              <input
                type="text"
                name="role"
                value={formData?.role}
                onChange={handleChange}
                placeholder="Enter Role Name"
                className="mt-3 w-full rounded-lg border-none bg-[#4285F426] py-[10px] px-4 text-white outline-none placeholder:text-[14px] placeholder:text-white/30 md:placeholder:text-[16px]"
              />
            </div>}
            <div className="w-full rounded-lg bg-[#18345A] p-3">
              <label className="text-[14px] text-white/70 md:text-[16px]">
                Where do you want to receive the CV & LinkedIn profile of {certificateData?.name?.split(" ")[0]}*
              </label>
              <input
                type="text"
                name="number"
                value={formData?.number}
                onChange={handleChange}
                placeholder="Enter your Mobile Number Here"
                className="mt-3 w-full rounded-lg border-none bg-[#4285F426] py-[10px] px-4 text-white outline-none placeholder:text-[14px] placeholder:text-white/30 md:placeholder:text-[16px]"
              />
            </div>
            <div className="w-full rounded-lg bg-[#18345A] p-3">
              <label className="text-[14px] text-white/70 md:text-[16px]">
                Reason of request*
              </label>
              <textarea
                type="text"
                name="reason"
                value={formData?.reason}
                onChange={handleChange}
                placeholder="Enter your Reason Here..."
                style={{
                  scrollbarWidth: "none", // Firefox
                  msOverflowStyle: "none",
                  resize: "none",
                }}
                contentEditable="true"
                className="mt-3 w-full rounded-lg border-none bg-[#4285F426] py-[10px] px-4 text-white outline-none placeholder:text-[14px] placeholder:text-white/30 md:placeholder:text-[16px]"
              />
            </div>
            <button className="rounded-lg disabled:opacity-50 bg-[#7FC241] px-8 py-2 text-[16px] font-medium text-[#121212] md:text-[18px]" type="submit" disabled={( variant!=="recruiter" ? false : !formData?.role)|| !formData?.number || !formData?.reason}>
              Submit
            </button>
          </form> : <div className="flex w-full flex-col mt-3 items-center justify-start gap-4 p-3 leading-none">
            <img alt="" src="https://assets.learntube.ai/files/Certificate%20Verification%20Screen/requestSent.png?updatedAt=1750526484583" className="w-[40px] h-[40px]" width={40} height={40} />
            <div className="flex w-full flex-col items-center justify-start gap-2 text-center">
                <div className="font-semibold text-[20px] text-white md:text-[22px]">CV & LinkedIn Request Sent</div>
                <div className="text-white/50 text-[14px] md:text-[16px] leading-[140%]">You will get CV & LinkedIn profile in your inbox shortly.</div>
            </div>
            </div>
        )}
      </div>
  
  );
};

export default RequestCV;
